module.exports = __webpack_public_path__ + "static/media/sb-warning.d9f6d701.svg";